module.exports = __webpack_public_path__ + "img/location.419f6a51.png";